import factory from '../requestFactory';
import store from '@/store'

export default ({service_id,timetable_id,date_time}) => {
    let params = {
        service_id: service_id,
        patient_id: store.getters.patient.id,
        date_time: date_time,
    }

    return factory()
        .get(`/time-table/${timetable_id}/pre-order`, {params: params})

};
